module.exports = __webpack_public_path__ + "static/img/5-open.0f96cb3c.png";